import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Button, Div, Flex, Gutter } from '@gaiads/telia-react-component-library';
import { SalesChannel } from '@cdaas/api-clients/dist/product-service-openapi';

interface BottomDrawerProps {
  selectedSalesChannels: SalesChannel[];
  handleEditSalesChannel: () => void;
  handleRemoveSalesChannels: () => void;
  resetSelections: () => void;
}

const BottomDrawer = ({ selectedSalesChannels, handleEditSalesChannel, handleRemoveSalesChannels, resetSelections }: BottomDrawerProps) => {
  const { t } = useTranslation('saleschannelsscreen');

  const selectedSalesChannelsCount = selectedSalesChannels.length;

  return (
    <div className="sticky-footer">
      <Div margin={{ horizontal: 'xxlg', vertical: 'md' }}>
        <Flex padding={{ horizontal: 'md' }}>
          <Flex flexItem alignBaseline spaceBetween>
            <Flex flexItem alignBaseline>
              <BodyText color={'white'}>{t('selected.selected', { count: selectedSalesChannelsCount })}</BodyText>
              <Gutter />
              {/* Button removed until functionality is implemented */}
              {/* <Button variant={'primaryWhite'} onClick={() => undefined}>{t('selected.exportPriceList')}</Button>
              <Gutter /> */}
              {selectedSalesChannelsCount === 1 && (
                <Button variant={'primaryWhite'} onClick={() => handleEditSalesChannel()}>
                  {t('selected.editSalesChannel')}
                </Button>
              )}
              <Gutter />
              <Button onClick={() => handleRemoveSalesChannels()} variant={'destructive'}>
                {t('selected.delete')}
              </Button>
              <Flex />
              <Flex flexItem alignBaseline alignRight>
                <Button textVariantProps={{ color: 'white' }} size={'xl'} onClick={() => resetSelections()} variant={'text'}>
                  {t('selected.cancel')}
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Div>
    </div>
  );
};

export default BottomDrawer;
